module.exports = __webpack_public_path__ + "static/media/2.557ea240.jpg";